import type { CSSProperties, ReactElement, ReactNode } from 'react';

type AccentCardProps = {
  readonly colour: string;
  readonly children: ReactNode;
  readonly as?: 'li' | 'div';
  readonly className?: string;
};

/** One consistent left-accent card shell, in place of the `border-l-[3px]` /
 * `border-l-4` split that had drifted between the pages that use it. */
export const AccentCard = ({
  colour,
  children,
  as = 'li',
  className = 'p-3.5',
}: AccentCardProps): ReactElement => {
  const Tag = as;
  const style: CSSProperties = { borderLeftColor: colour };

  return (
    <Tag
      className={`bg-surface rounded-card border-subtle border border-l-[3px] ${className}`}
      style={style}
    >
      {children}
    </Tag>
  );
};
